import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();

  private loadingCounter = 0;
  private loadingMessage = '';

  /**
   * Mostra il loading spinner
   */
  show(message: string = 'Caricamento in corso...'): void {
    this.loadingCounter++;
    this.loadingMessage = message;
    this.loadingSubject.next(true);
  }

  /**
   * Nasconde il loading spinner
   */
  hide(): void {
    this.loadingCounter--;

    if (this.loadingCounter <= 0) {
      this.loadingCounter = 0;
      this.loadingSubject.next(false);
      this.loadingMessage = '';
    }
  }

  /**
   * Forza nascondere il loading (anche se ci sono più richieste attive)
   */
  forceHide(): void {
    this.loadingCounter = 0;
    this.loadingSubject.next(false);
    this.loadingMessage = '';
  }

  /**
   * Ottiene il messaggio di loading corrente
   */
  getMessage(): string {
    return this.loadingMessage;
  }

  /**
   * Verifica se il loading è attivo
   */
  isLoading(): boolean {
    return this.loadingSubject.value;
  }
}
